import React, { useState } from "react";
import { CloseOutlined, DiffOutlined, EyeOutlined, UnorderedListOutlined } from '@ant-design/icons';
import { Modal, Col, Row, Table, Button, Tooltip, Space, FloatButton, } from 'antd';
import { AlignType } from 'rc-table/lib/interface';
import dayjs from "dayjs";

import { IAuditoria } from "../Interfaces/DadosPrevicInterfaces";

import { errorMessage, infoMessage, mostrarInfo } from "../utils/messages";
import SideBySideDiff from "./AuditoriaDiffViewr";

interface IProps {
  dadosAuditoria: IAuditoria[];
  setRegistroHistorico: React.Dispatch<React.SetStateAction<IAuditoria | undefined>>;
}

export interface ICampos {
  visible?: string[];
  default?: string[];
  defaultNumberSelect?: number[];
  required?: number[];
  disabled?: number[];
}


const Auditoria = ({ dadosAuditoria, setRegistroHistorico }: IProps) => {

  const [exibirModalDiff, setExibirModalDiff] = useState(false);
  const [exibirModalEventos, setExibirModalEventos] = React.useState<boolean>(false);
  const [audSelected, setAudSelected] = React.useState<IAuditoria>();

  const [jsonInicial, setJsonInicial] = useState("");
  const [jsonFinal, setJsonFinal] = useState("");

  const setFieldsDiff = (aud: IAuditoria) => {
    if (!aud.corpoPos && aud.corpoPos === "") {
      mostrarInfo("Não foi possível fazer a comparação", "O registro mais recente não está disponível. Tente pesquisar novamente antes de tentar exibir esta comparação");
    } else {

      let jsonTxt1 = aud.corpoPre;
      let jsonTxt2 = aud.corpoPos;

      let json1 = JSON.parse(jsonTxt1);
      let json2 = JSON.parse(jsonTxt2);

      const text1 = JSON.stringify(json1, null, 2);
      const text2 = JSON.stringify(json2, null, 2);

      setJsonInicial(text1);
      setJsonFinal(text2);
      controleDaGrid("exibirModalDiff");
    }
  }


  const columns = [
    {
      key: "1",
      title: "Data do Evento",
      render: (IAud: IAuditoria) => (
        <>
          {IAud.dtPos && IAud.dtPos !== "" ? dayjs(IAud.dtPos).format("DD/MM/YYYY HH:mm") : "Histórico carregado de forma incompleta. Consulte o registro novamente"}
        </>
      ),
    },
    {
      key: "2",
      title: "Data do registro",
      render: (IAud: IAuditoria) => (
        <>
          {IAud.dtPre && IAud.dtPre !== "" ? dayjs(IAud.dtPre).format("DD/MM/YYYY HH:mm") : ""}
        </>
      ),
    },
    {
      key: "3",
      title: "Eventos",
      render: (IAud: IAuditoria) => (
        <>
          {IAud.eventos && IAud.eventos.length === 1
            ? IAud.eventos[0]
            : IAud.eventos.length > 1
              ?
              <>
                <Tooltip title="Clique para ver todos os eventos associados">
                  <UnorderedListOutlined onClick={() => showModalEventos(IAud)} />
                </Tooltip>
              </>
              : "Histórico carregado de forma incompleta. Consulte o registro novamente"
          }
        </>
      ),
    },
    {
      key: "4",
      title: "Origem",
      dataIndex: "tpUsuarioPos",
    },
    {
      key: "5",
      title: "Usuário",
      dataIndex: "usuarioPos",
    },
    {
      key: "111",
      title: "Opções",
      align: 'center' as AlignType,
      render: (IAud: IAuditoria) => (
        <Space style={{justifyContent: 'center'}}>
          <Tooltip title="Exibir registro histórico">
            <Button
              id="detalhe"
              shape="round"
              icon={<EyeOutlined />}
              htmlType="button"
              onClick={() => {
                if (IAud?.corpoPre && IAud.corpoPre !== "") {
                  setRegistroHistorico(IAud);
                } else {
                  if (IAud.onlyInsert) {
                    infoMessage("Este registro histórico é somente de inserção. Não existe posição anterior para exibir.");
                  } else {
                    errorMessage("Erro: registro anterior para exibição não localizado. Se o erro persisitr entre em contato com o administrador do sistema.");
                  }
                }
              }}
            />
          </Tooltip>

          <Tooltip title="Exibir diferença">
            <Button
              // style={{ display: IAud.corpoPre || IAud.corpoPre !== "" ? "inline" : "none" }}
              id="diff"
              shape="round"
              icon={<DiffOutlined />}
              htmlType="button"
              onClick={() => {
                if (IAud?.corpoPos && IAud.corpoPos !== "") {
                  if (IAud.onlyInsert) {
                    infoMessage("Este registro histórico é somente de inserção. Não existe posição anterior para comparação.");
                  } else if (IAud?.corpoPre && IAud.corpoPre !== "") {
                    setFieldsDiff(IAud);
                  } else {
                    errorMessage("Erro: registro anterior para comparação não localizado. Se o erro persisitr entre em contato com o administrador do sistema.");
                  }
                } else {
                  errorMessage("Erro: não existe registro posterior para comparação. Tente fazer a consulta novamente.");
                }
              }}

            />
          </Tooltip>
        </Space>
      ),
    },
  ];

  const handleCancel = () => {
    controleDaGrid("cancelar");
  };

  const controleDaGrid = (botao: string) => {

    if (botao === "cancelar") {
      setExibirModalDiff(false);
    } else if (botao === "incluir") {
      setExibirModalDiff(false);
    } else {
      setExibirModalDiff(true);
    }

  };

  const showModalEventos = (aud: IAuditoria) => {
    setAudSelected(aud);
    setExibirModalEventos(true);
  };

  return (

    <>
      <>
        <Modal title="Comparação de registros" open={exibirModalDiff}
          style={{ top: 20 }}
          destroyOnHidden={true}
          width={"80%"}
          closable={false}
          footer={[
            <FloatButton icon={<CloseOutlined />} key="cancelFechar" onClick={handleCancel} >
              Fechar
            </FloatButton>,
          ]}
        >
          <>
            <Row>
              <SideBySideDiff oldText={jsonInicial} newText={jsonFinal} />
            </Row>

          </>
        </Modal>
      </>

      <Modal
        title={<p>Eventos do Histórico</p>}
        style={{ top: 20 }}
        destroyOnHidden={true}
        // width={500}
        closable={false}
        footer={[
          <Button icon={<CloseOutlined />} shape="round" key="cancelFechar" onClick={() => setExibirModalEventos(false)}>
            Fechar
          </Button>,
        ]}
        open={exibirModalEventos}
      >

        {audSelected?.eventos?.map((evento: string) => (
          <React.Fragment key={evento}>
            {evento}
            <br />
          </React.Fragment>
        ))}
      </Modal>


      <Row>
        <Col
          xs={24}
          sm={24}
        >
          <Table
            size="small" columns={columns} dataSource={dadosAuditoria} pagination={false} />
        </Col>
      </Row>
    </>
  )
};

export default Auditoria;